import { apiEnvironment } from '../smoothr-web-app-core/environments/apiEnvironment';
import packageJson from '../../package.json';

export const dndCustomerGroup = 'dean_and_david';
export const customerGroup = dndCustomerGroup;

const supportEmail = {
	dean_and_david: 'dean_and_david@smoothr.de',
};
const firebaseConfig = {
	dean_and_david: {
		apiKey: 'AIzaSyBgQ_LSUpazFB09uhSYSrvdp6A6XVUVQGQ',
		authDomain: 'eam-outlet.firebaseapp.com',
		projectId: 'eam-outlet',
		storageBucket: 'eam-outlet.appspot.com',
		messagingSenderId: '415039699499',
		appId: '1:415039699499:web:94886645cf34f4e7f8886e',
		measurementId: 'G-Y7MZXF6N53',
	},
};
export const environment = {
	customerGroup,
	webAppUrl: window.location.protocol + '//' + window.location.host,
	placesApiKey: 'AIzaSyDx99_I34aUK3cLhF7zTI6Uxcq6FP9qKvA',
	turnstileSiteKey: '0x4AAAAAAFiCJTbIC4Tz7JhL',
	SUPPORT_EMAIL: supportEmail[customerGroup],
	firebaseConfig: firebaseConfig[customerGroup],
	APAY_MERCHANT_ID: 'merchant.smoothr.' + customerGroup + '-dev',
	...apiEnvironment,
	countryList: ['de', 'at', 'lu'],
	countyNameList: ['Germany', 'Austria', 'Luxembourg'],
	gaId: firebaseConfig[customerGroup].measurementId,
	hasRecommendations: true,
	apiUrl: 'https://dev-dean-and-david.smoothr.de/',
	location: '',
	deactivateDelivery: false,
	enableCashPayment: false,
	allowNavigationToWorldline: false,
	appVersion: packageJson.version,
};

import 'zone.js';
